import { AuditStatusDetailType, AuditStatusType } from '@/const/status';
import { getUserId } from '@/login/login';
import { isWoa } from '@/utils/getApiDomain';

const disabledStory = (status: AuditStatusType | AuditStatusDetailType) => {
  const isDisabled = status === AuditStatusType.STATUS_TYPE_MANUAL_ING;
  return isDisabled;
};

const isAuthor = (createdBy: string) => {
  const uid = getUserId();
  return String(uid) === String(createdBy);
};

// 节点是否可以删除，已发布的不可删除,内网也不可删除 , 这里已经包含了状态集合，所以不用取状态
const nodeCanDelete = (data: { publishedAt?: string }) => !data?.publishedAt && !isWoa;

export { disabledStory, isAuthor, nodeCanDelete };
